export default {
  newDesign: true,
  parameters: {
    landing_id: "LatQuCoHab",
    segment: 14,
    success_page: "success_long",
  },
  title:
    "¿Quieres saber qué habilidades son especialmente importantes para tu hijo? | Kodland",
  downtimeUrl: "https://www.kodland.org/es",
  startPage: {
    title:
      "¿Quieres saber qué habilidades es especialmente importante desarrollar en tu hijo?",
    subtitle:
      "Realiza esta prueba única y recibe recomendaciones en solo 3 minutos. Responde algunas preguntas y recibe una guía personalizada 💙<br>✔️ Elaborado por expertos en educación<br>❤️ Completamente gratuito<br>👪 Más de 100 mil padres confían en nosotros",
    image: {
      url: "/welcome/latam_coding_habilities_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/latam_coding_habilities_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "¡Empieza ahora! 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Lamentablemente, las tabletas y los teléfonos no son adecuados para nuestras clases. ¡Esperamos verte en nuestras lecciones en otra ocasión!",
  },
  quizRotateBySteps: {
    1: {
      title: "¿Cuántos años tiene tu hijo?",
      type: "age",
      button: "",
    },
    2: {
      question:
        "¿Tiene tu hijo acceso a una laptop o PC de escritorio para estudiar?",
      answers: [
        "Sí, tiene su propio dispositivo 💻✅",
        "Sí, pero lo comparte con otros 🖥️👫",
        {
          answer: "No, no tiene acceso regular 🚫",
          stopAnswer: true,
        },
      ],
    },
    3: {
      question: "¿Cuánto tiempo usa tu hijo dispositivos al día?",
      answers: [
        "Menos de una hora 🕒",
        "1-2 horas 📱",
        "3-4 horas 💻",
        "Más de 5 horas ⏳",
        "No usa dispositivos 📵",
      ],
    },
    4: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 3, answer: "Menos de una hora 🕒" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/review_es.png",
            title: "¡Felicidades! 🎉",
            subtitle:
              "Tu hijo cumple con el estándar recomendado a nivel mundial. Al final del test, te daremos consejos para que el tiempo frente a la pantalla sea productivo 👀",
            button: "Todo claro 👌",
          },
        },
        {
          condition: [{ step: 3, answer: "1-2 horas 📱" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/review_es.png",
            title: "¡Felicidades! 🎉",
            subtitle:
              "Tu hijo cumple con el estándar recomendado a nivel mundial. Al final del test, te daremos consejos para que el tiempo frente a la pantalla sea productivo 👀",
            button: "Todo claro 👌",
          },
        },
        {
          condition: [{ step: 3, answer: "3-4 horas 💻" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/review_es.png",
            subtitle:
              "Actualmente, se recomienda que los niños de 8 a 17 años pasen no más de 2-3 horas al día frente a una pantalla. Al final del test, te daremos consejos para hacer que ese tiempo sea productivo 👀",
            button: "Todo claro 👌",
          },
        },
        {
          condition: [{ step: 3, answer: "Más de 5 horas ⏳" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/review_es.png",
            subtitle:
              "Actualmente, se recomienda que los niños de 8 a 17 años pasen no más de 2-3 horas al día frente a una pantalla. Al final del test, te daremos consejos para hacer que ese tiempo sea productivo 👀",
            button: "Todo claro 👌",
          },
        },
        {
          condition: [{ step: 3, answer: "No usa dispositivos 📵" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/review_es.png",
            subtitle:
              "La computadora y el smartphone son parte fundamental de la vida moderna, el aprendizaje y la carrera profesional, incluso si a veces parecen perjudiciales para los niños. Al final del test, te daremos consejos para que su tiempo frente a la pantalla sea productivo 👀",
            button: "Todo claro 👌",
          },
        },
      ],
    },
    5: {
      question:
        "¿Tu hijo se siente cómodo usando tecnología como computadoras, aplicaciones o tareas básicas en internet?",
      answers: [
        "Muy cómodo, usa seguido 💻",
        "Tareas básicas, con ayuda 📱",
        "No está familiarizado 🚫",
      ],
    },
    6: {
      question:
        "Descubramos en qué destaca tu hijo y qué puede seguir desarrollando. ¿Cuál es su materia favorita en la escuela?",
      answers: [
        "Ciencias o mate 🧪🔢",
        "Leer/escribir historias 📚✍️",
        "Arte, música 🎨🎶",
        "Deportes ⚽🏅",
        "Otro 🙂",
      ],
    },
    7: {
      question: "¿Qué le gusta hacer en su tiempo libre?",
      answers: [
        "Hacer deportes al aire libre ⚽",
        "Pasar tiempo en redes sociales 📱",
        "Leer libros o cómics 📚",
        "Ver YouTube o videojuegos 🎮",
        "Pasar tiempo con amigos o familia 👫",
        "Otro 🙂",
      ],
    },
    8: {
      question: "¿Cuál de estas opciones describe mejor a tu hijo?",
      answers: [
        "Líder de clase 👑",
        "Hiperactivo ⚡",
        "Creativo por naturaleza 🎨",
        "Tranquilo y reservado 🌸",
        "Ninguna de las anteriores ❓",
      ],
    },
    9: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_coding_habilities_q9.png",
      subtitle:
        "Para el desarrollo integral de un niño, tanto las habilidades técnicas como las sociales son clave. Al igual que leer y contar, se pueden fortalecer en cualquier tipo de personalidad.<br>Al final del test, descubrirás cómo ayudar a tu hijo a desarrollarlas ✨",
      button: "¡Perfecto!",
    },
    10: {
      question:
        "¿Qué materias le resultan más difíciles a tu hijo en la escuela?",
      answers: ["Técnicas 🛠️", "Creativas 🎨", "No estoy seguro/a ❓"],
    },
    11: {
      question: "¿Cómo es su rendimiento académico?",
      answers: ["Alumno destacado 🏅", "Buen estudiante 👍", "Promedio 📚"],
    },
    12: {
      question: "¿Tiene amigos?",
      answers: ["Sí, muchos 👫", "Sí, 1-2 👯", "No tiene amigos 🚶"],
    },
    13: {
      question:
        "¿Cómo evaluarías el comportamiento de tu hijo en los últimos 6 meses?",
      answers: [
        "Bien educado y tranquilo 😌",
        "A veces impulsivo o agresivo 😡",
        "Muy tímido e inseguro 😕",
        "No estoy seguro/a 🤔",
      ],
    },
    14: {
      question: "¿Tu hijo sabe qué quiere ser cuando crezca?",
      answers: [
        "Sí, eligió una profesión 👩‍⚖️",
        "No lo ha pensado 🤷‍♂",
        "Varias opciones 🎨⚽",
        "No estoy seguro/a 🤷‍♀️",
      ],
    },
    15: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 10, answer: "Técnicas 🛠️" }],
          data: {
            typeInfo: "noQuestions",
            title: "¡Gracias por completar el test! 🎯",
            subtitle:
              "Hemos analizado tus respuestas y las recomendaciones están listas. En primer lugar, nuestros expertos sugieren desarrollar el 🧠🧩 <strong>Pensamiento lógico</strong>.<br><br>Esta habilidad ayudará a tu hijo a resolver problemas complejos por sí mismo y mejorar en materias técnicas. Resuelvan acertijos juntos, analicen situaciones desde diferentes perspectivas y verás su progreso ✨",
            button: "Continuar leyendo ➡️",
          },
        },
        {
          condition: [{ step: 10, answer: "No estoy seguro/a ❓" }],
          data: {
            typeInfo: "noQuestions",
            title: "¡Gracias por completar el test! 🎯",
            subtitle:
              "Hemos analizado tus respuestas y las recomendaciones están listas. En primer lugar, nuestros expertos sugieren desarrollar el 🧠🧩 <strong>Pensamiento lógico</strong>.<br><br>Esta habilidad ayudará a tu hijo a resolver problemas complejos por sí mismo y mejorar en materias técnicas. Resuelvan acertijos juntos, analicen situaciones desde diferentes perspectivas y verás su progreso ✨",
            button: "Continuar leyendo ➡️",
          },
        },
        {
          condition: [{ step: 10, answer: "Creativas 🎨" }],
          data: {
            typeInfo: "noQuestions",
            title: "¡Gracias por completar el test! 🎯",
            subtitle:
              "Hemos analizado tus respuestas y las recomendaciones están listas. En primer lugar, nuestros expertos sugieren desarrollar el 💡🎨 <strong>Pensamiento creativo</strong>.<br><br>La capacidad de generar ideas innovadoras ayudará a tu hijo a resolver problemas de forma original y destacar en materias creativas. Organiza sesiones de lluvia de ideas sobre cualquier tema y celebra las ideas más inusuales 🌟",
            button: "Continuar leyendo ➡️",
          },
        },
      ],
    },
    16: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 8, answer: "Líder de clase 👑" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
              "También recomendamos prestar atención a la 🗣️🤝 <strong>Resolución de conflictos</strong>.<br><br>Los niños activos pueden tener dificultad para considerar las emociones de otros. Ayúdalo compartiendo cómo te sientes en sus interacciones y analizando juntos las reacciones de personajes en películas o series 📺",
            button: "Ver las últimas 3 recomendaciones 👀",
          },
        },
        {
          condition: [{ step: 8, answer: "Hiperactivo ⚡" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
              "También recomendamos prestar atención a la 🗣️🤝 <strong>Resolución de conflictos</strong>.<br><br>Los niños activos pueden tener dificultad para considerar las emociones de otros. Ayúdalo compartiendo cómo te sientes en sus interacciones y analizando juntos las reacciones de personajes en películas o series 📺",
            button: "Ver las últimas 3 recomendaciones 👀",
          },
        },
        {
          condition: [{ step: 8, answer: "Tranquilo y reservado 🌸" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",

            subtitle:
              "Además, es importante trabajar en la 💪🗣️ <strong>Autoconfianza</strong>.<br><br>Por muy talentoso que sea un niño, la timidez excesiva puede limitar su éxito. Es clave que desarrolle habilidades de comunicación y autoexpresión. Anímalo a interactuar en distintos grupos y a expresar sus ideas con seguridad ✨",
            button: "Ver las últimas 3 recomendaciones 👀",
          },
        },
        {
          condition: [{ step: 8, answer: "Ninguna de las anteriores ❓" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
              "Además, es importante trabajar en la 💪🗣️ <strong>Autoconfianza</strong>.<br><br>Por muy talentoso que sea un niño, la timidez excesiva puede limitar su éxito. Es clave que desarrolle habilidades de comunicación y autoexpresión. Anímalo a interactuar en distintos grupos y a expresar sus ideas con seguridad ✨",
            button: "Ver las últimas 3 recomendaciones 👀",
          },
        },
        {
          condition: [{ step: 8, answer: "Creativo por naturaleza 🎨" }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/quiz_br_2.webp",
            subtitle:
              "Además, es importante trabajar en la 💪🗣️ <strong>Autoconfianza</strong>.<br><br>Por muy talentoso que sea un niño, la timidez excesiva puede limitar su éxito. Es clave que desarrolle habilidades de comunicación y autoexpresión. Anímalo a interactuar en distintos grupos y a expresar sus ideas con seguridad ✨",
            button: "Ver las últimas 3 recomendaciones 👀",
          },
        },
      ],
    },
    17: {
      typeInfo: "noQuestions",
      subtitle:
        "<strong>⏰📅 Gestión del tiempo.</strong> El éxito depende de la capacidad para planificar y establecer metas. Anímalo a fijar 3 tareas principales cada día para visualizar su progreso y aumentar su motivación ✅<br><strong>🔄📱 Adaptación rápida a los cambios.</strong> Con nuevas profesiones y tecnologías surgiendo constantemente, es clave adaptarse y seguir aprendiendo. Juegos con tramas impredecibles pueden ayudar a desarrollar esta habilidad 🎮<br><strong>🎯👨‍🎓 Conciencia al elegir una profesión.</strong> Es fundamental que reconozca sus intereses y talentos para elegir una profesión que lo haga feliz y exitoso. Muéstrale diferentes caminos a través de talleres y cursos 🌟",
      button: "Recibir mi regalo 🎁",
    },
    18: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/latam_coding_habilities_q18.png",
      subtitle:
        "¿Cómo puede tu hijo desarrollar todas estas habilidades en un solo lugar? 🤔<br>¡Tenemos un regalo especial para ti! Por completar el test, te regalamos una <strong>clase gratuita</strong> en la escuela de programación Kodland 🎁<br>A través de la creación de juegos y sitios web junto a otros niños, tu hijo desarrollará:<br>🧠 Pensamiento lógico y creativo<br>🗣️ Habilidades de comunicación<br>⏰ Gestión del tiempo y adaptación<br>100% online, en vivo y con un profesor de verdad ✨",
      button: "Reservar mi clase gratuita 🔥",
    },
    19: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
      button: "Elige una fecha ➡️",
    },
    20: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    21: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    22: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    23: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};
